import { makeVar } from '@apollo/client';

import { DEFAULT_FILTERS } from './constants';
import type { MenuTemplateFilters } from './types';

export const selectedVendorIdVar = makeVar<string | null>(null);
export const selectedTemplateIdVar = makeVar<string | null>(null);
export const filtersVar = makeVar<MenuTemplateFilters>(DEFAULT_FILTERS);
